import Button from '@atlaskit/button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import React from 'react';
import ReportDetailsContent from "../ReportDetailsContent";

const ReportDetailsModal = ({
  reportDetails,
  reportDetailsConfig,
  onClose,
  header,
  size
}) => /*#__PURE__*/React.createElement(ModalTransition, null, /*#__PURE__*/React.createElement(Modal, {
  onClose: onClose,
  width: size || 'x-large'
}, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, null, header)), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(ReportDetailsContent, {
  reportDetails: reportDetails,
  reportDetailsConfig: reportDetailsConfig
})), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
  appearance: "primary",
  onClick: onClose
}, "Close"))));

export default ReportDetailsModal;